import {
    cilGroup,
    cilPencil,
    cilReload,
    cilSearch,
    cilTrash,
  } from "@coreui/icons";
  import swal from "sweetalert";
  
  import CIcon from "@coreui/icons-react";
  import {
    CButton,
    CCol,
    CFormInput,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CRow,
    CTable,
    CTableBody,
    CTableCaption,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
  } from "@coreui/react";
  import React, { useEffect, useState } from "react";
  import { Link, useNavigate } from "react-router-dom";
  import adminAxiosInstance from "../../../config";
  import ReactPaginate from "react-paginate";
  import err404 from "../../../errors/svg/noData.jpg";
  import err500 from "../../../errors/svg/err500.svg";
  import moment from "moment";
  
  import bckSvg from "../../../User/assets/svg/backArrow.svg";
  import frtSvg from "../../../User/assets/svg/frontArrow.svg";
  
  const UserOtp = () => {
    const [visible, setVisible] = useState(false);
    const [user, setUser] = useState([]);
    const [staffid, setStaffid] = useState("");
  
  
    const [data, setData] = useState([]);
    const [id, setId] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(200);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchData, setSearchData] = useState("");
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [drop, setDrop] = useState("");
    const adminToken = localStorage.getItem("token");
  
  
    const navigate = useNavigate();
  
    let limit = 10;
    let totalCount;
  
    const fetchData = async (currentPage, searchData) => {
      setLoading(true);
      try {
        const response = await adminAxiosInstance.get(
          `/otp/getAll?page=${currentPage}&limit=${limit}&str=${searchData}&startDate=${fromDate ? fromDate : ""
          }&endDate=${toDate ? toDate : ""}&isAssign=${drop}`,

        // `/admin/otp/getAll?page=${currentPage}&limit=${limit}`,
          {
            headers: { Authorization: `Bearer ${adminToken}` },
          }
        );
        // console.log(response,"hsudhbsaudk")
        response?.data?.data.result?.forEach((element) => {
          element.momentDate = moment(element.createdAt).format(
            "DD-MM-YYYY h:mm:ss"
          );
        });
        // console.log("response usser", response);
        totalCount = parseInt(response?.data?.data?.total_count);
        setPageCount(Math.ceil(totalCount / limit));
        if (response?.status === 200) {
          setData(response.data.data);
          setError(200);
          setLoading(false);
        }
      } catch (error) {
        if (error.response.status === 404) {
          setError(404);
          setLoading(false);
          setData([]);
        } else {
          setError(500);
          setLoading(false);
        }
      }
    };
  
    const apiCall = async (id, employeeId) => {
      try {
        // const response = await adminAxiosInstance.get(`userManage/assignemployee/${id}?employeeId=${employeeId}`);
        const response = await adminAxiosInstance.put(`assign/assingEmployee/${employeeId}`, {
          userId: [id]
        },      
        {
          headers: { Authorization: `Bearer ${adminToken}` },
        }
        );
        // console.log("response=======>", response);
        if (response?.status == 200) {
          swal({
            title: "Employee assign Successful ",
            icon: "success",
            button: false,
            timer: 1000,
          })
  
        }
        // setUser(response.data.data.result);
        // setData(response?.data?.data);     
        // setUrl(response?.data?.data[0]?.profileImage);
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
  
      }
    };
  
    const allUser = async () => {
      // setLoading(true);
  
      try {
        const response = await adminAxiosInstance.get("/employee/getAllUser",
        {
          headers: { Authorization: `Bearer ${adminToken}` },
        }
        );
  
        // console.log("response=======>", response);
        setUser(response.data.data.result);
  
        // setData(response?.data?.data);
        // setUrl(response?.data?.data[0]?.profileImage);
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        // console.log("error=====>", error);
        // console.log("setUser=====>", setUser);
      }
    };
  
    const handleDelete = async (id) => {
      try {
        const deleteData = await adminAxiosInstance.delete(
          `/userManage/delete/${id}`,
          {
            headers: { Authorization: `Bearer ${adminToken}` },
          }
        );
        if (deleteData.status === 200) {
          setVisible(false);
          fetchData(1, "");
        }
      } catch (error) {
        // console.log("Error===>", error.response.data.message);
      }
    };
  
    const handleReset = () => {
      setFromDate("");
      setToDate("");
      document.getElementById("datez").value = "dd/mm/yy";
      document.getElementById("dates").value = "dd/mm/yy";
    };
  
    const handleExport = async () => {
      navigate("/admin/userlist");
    };
  
    const handlePageClick = (data) => {
      // console.log(data.selected);
      setCurrentPage(data.selected + 1);
      // console.log(currentPage);
    };
    const pageData = async (currentPage) => {
      fetchData(currentPage, searchData);
    };
  
    useEffect(() => {
      fetchData(1, searchData);
    }, [fromDate, toDate]);
  
    useEffect(() => {
      fetchData(currentPage, searchData);
    }, [searchData , drop]);
  
    useEffect(() => {
      pageData(currentPage);
    }, [currentPage]);
    useEffect(() => {
      fetchData(1, "");
      allUser();
      apiCall();
  
    }, []);
  
    return (
      <>
        <div className="d-flex">
          <CIcon icon={cilGroup} size="xxl" />
          <h3>Otp List</h3>
        </div>

        {loading ? (
          <>
            <div className="loader-content">
              <div className="spinner-border text-secondary"></div>
            </div>
          </>
        ) : (
          <>
            <div className="bg-white mt-3 ps-3 pe-3 pb-1 mb-3">
              <CTable caption="top" responsive>
                {error === 200 ? (
                  <>
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell scope="col">Sr.No.</CTableHeaderCell>
                        <CTableHeaderCell scope="col">Mobile No.</CTableHeaderCell>
                        <CTableHeaderCell scope="col">Otp</CTableHeaderCell>
                        <CTableHeaderCell scope="col">Created At</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {data ? (
                        data.result?.map((item, index) => (
                          <CTableRow key={index}>
                            <CTableHeaderCell scope="row">
                              {index}
                              {/* {console.log("indexsdsfd",index)} */}
                            </CTableHeaderCell>
                            <CTableDataCell>
                              {item?.mobile ? item?.mobile : "-"}
                            </CTableDataCell>
                            <CTableDataCell>
                              {item?.otp ? item?.otp : "-"}
                            </CTableDataCell>
                            <CTableDataCell>
                              {item?.createdAt ? item?.createdAt : "-"}
                            </CTableDataCell>
                          </CTableRow>
                        ))
                      ) : (
                        <>
                          <CTableRow>
                            <CTableDataCell colSpan={7}>
                              {error ? error : "Something went wrong!"}
                            </CTableDataCell>
                          </CTableRow>
                        </>
                      )}
  
                      {/* Confirm Delete Modal */}
                      <CModal
                        alignment="center"
                        visible={visible}
                        onClose={() => setVisible(false)}
                      >
                        <CModalHeader>
                          <CModalTitle>Confirm Deletion</CModalTitle>
                        </CModalHeader>
                        <CModalBody>
                          Are you sure you want to delete this item?
                        </CModalBody>
                        <CModalFooter>
                          <CButton
                            color="secondary"
                            className="text-white"
                            onClick={() => setVisible(false)}
                          >
                            Close
                          </CButton>
                          <CButton
                            color="danger"
                            className="text-white"
                            onClick={() => handleDelete(id)}
                          >
                            Delete
                          </CButton>
                        </CModalFooter>
                      </CModal>
                      {/* <CTableRow>
                        <CTableHeaderCell colSpan="12" scope="row">
                          Total Result : {data?.result?.length}
                        </CTableHeaderCell>
                      </CTableRow> */}
                    </CTableBody>
                  </>
                ) : error === 404 ? (
                  <CTableBody>
                    <CTableRow>
                      <CTableDataCell className="d-flex justify-content-center">
                        <img
                          src={err404}
                          alt=""
                          style={{ height: "400px", width: "400px" }}
                        />
                      </CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                ) : (
                  <CTableBody>
                    <CTableRow>
                      <CTableDataCell className="d-flex justify-content-center">
                        <img
                          src={err500}
                          alt=""
                          style={{ height: "400px", width: "400px" }}
                        />
                      </CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                )}
              </CTable>
            </div>
          </>
        )}
        {error === 200 ? (
          pageCount && pageCount > 1 ? (
            <>
              <div className="myPaginationBottom">
                <span>Total Result : {data?.result?.length}</span>
                <ReactPaginate
                  previousLabel={
                    <>
                      <img src={bckSvg} alt="backButton" />
                    </>
                  }
                  nextLabel={
                    <>
                      <img src={frtSvg} alt="frtButton" />
                    </>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </>
    );
  };
  
  export default UserOtp;
  